import React, { Component } from "react";

import ApplicatedQuestionItem from "./ApplicatedQuestionItem/ApplicatedQuestionItem";

import "./styles.css";

class ApplicatedQuestionItemsMenu extends Component {
  render(props) {
    return (
      <ul className="applicated-question-item-list">
        {this.props.items?.map(item => (
          <li key={item.id}>
            <ApplicatedQuestionItem
              showAnswers={this.props.showAnswers}
              finished={this.props.finished}
              questionId={this.props.questionId}
              questionType={this.props.questionType}
              itemData={item}
              userAnswer={this.props.userAnswer.find(
                answer => answer.id === item.id
              )}
              answerChanger={this.props.answerChanger}
            />
          </li>
        ))}
      </ul>
    );
  }
}

export default ApplicatedQuestionItemsMenu;
